export default "__VITE_ASSET__BbJfdD2X__"